export const DEFAULT_REQUEST_TIMEOUT = 10 * 1000; // 10 seconds
export const DEFAULT_METADATA_REQUEST_TIMEOUT = 60 * 1000; // 60 seconds
export const DEFAULT_METADATA_REFRESH_INTERVAL = 10 * 60 * 1000; // 10 minutes
export const DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL = 10; // 10 milliseconds
